import React from 'react';
import AuthCheckManager from '../../Utils/AuthCheck/ManagerCheck.auth';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { CourseContainer } from '../../UserRoutes/UserHomepage/UserHomeStyles.styles';

const CompanyFormsPage = () => {
  return (
    <AuthCheckManager>
      <HelmetHelper
        title="Company Forms"
        description="List of the company forms"
      />
      <CourseContainer>
        <BreadCrumbs one="Company Dashboard" oneLink={`/company`} two="Forms" />
        <h2>Forms</h2>
      </CourseContainer>
    </AuthCheckManager>
  );
};

export default CompanyFormsPage;
